<template>
  <div>
    <div class="main-content-wrapper">
      <div class="top-info">
        <div class="date-info">
          <div class="time">{{ currentTime }}</div>
          <div class="top-wd">
<!--            <div class="weekday">{{ currentWeekday }}</div>-->
            <div class="date">{{ currentDate }}</div>
          </div>
        </div>
        <div class="top-bar"><img src="@/assets/top.png" alt="头部图片" /></div>
        <div class="current-count">
          当日元气恢复人数:
          <div class="digit-container">
            <div
              v-for="(digit, index) in String(ongoingTreatmentCount || 0).padStart(3, '0')"
              :key="`digit-${index}`"
              class="digit"
            >
              {{ digit }}
            </div>
          </div>
        </div>
      </div>
      <div class="modules-wrapper" ref="modulesWrapper">
        <div
          class="frame-item"
          v-for="(item, index) in displayedAppointments"
          :key="index"
          :class="{'fade-in': item && item.isNew}"
        >
          <template v-if="item">
            <div class="top-content" :class="getTreatmentStatusClass(item)">
              <div class="room-info">
                <img :src="getTreatmentStatusIcon(item)" alt="状态图标" class="status-icon" loading="lazy" />
                {{ item.roomName }}
              </div>
              <div class="treatment-therapist-container">
                <div class="time-info">
                  {{ getTreatmentStatus(item) }} ({{ formatTimeDisplay(item.startTime) }}~{{ formatTimeDisplay(item.endTime) }})
                </div>
                <span>|</span>
                <div class="therapist-info">治疗师 : {{ formatTherapistName(item.doctorName) }}</div>
              </div>
            </div>
            <div class="main-content">
              <div class="character-section">
                <div class="character-map">
                  <img :src="getCharacterImage(item)" alt="人物图" loading="lazy" />
                  <div class="bubble-container">
                    <div v-for="bubble in item.bubbles" :key="bubble.id" class="sleep-bubble" v-show="bubble.visible" :style="{ opacity: bubble.opacity || 1, top: bubble.position && bubble.position.top, left: bubble.position && bubble.position.left, right: bubble.position && bubble.position.right, bottom: bubble.position && bubble.position.bottom }">
                      <div class="bubble-bg"></div>
                      <div class="bubble-text">+{{ bubble.value }}</div>
                    </div>
                  </div>
                </div>
                <div class="patient-huanzhe">
                  <div class="patient-name-container">
                    <img :src="item && item.patientGender === 1 ? require('@/assets/icon_male.png') : require('@/assets/icon_female.png')" class="gender-icon" alt="性别图标" loading="lazy" />
                    <span style="color: #00122E;font-weight: bold;">{{ formatPatientName(item.patientName) }}</span>
                    <div class="sleep-status" :class="{'completed-status': getTreatmentStatus(item) === '已结束', 'ongoing-status': getTreatmentStatus(item) === '治疗中'}">
                      {{ getSleepStatus(item) }}
                    </div>
                  </div>
                  <div class="bottom-content">
                    <div class="progress-container">
                      <div class="custom-progress-bar">
                        <div class="progress-track">
                          <div class="progress-fill" :style="{ width: Math.min(getProgressPercentage(item), 100) + '%' }">
                            <div class="progress-glow"></div>
                            <div class="progress-percentage">{{ getProgressPercentage(item) }}%</div>
                          </div>
                        </div>
                      </div>
                      <div class="progress-info">
                        <div class="progress-label">元气恢复进度</div>
                        <div class="progress-score">
                          <span class="score-numerator">{{ calculateEnergyScore(item) }}</span>
                          <span class="score-separator"> / </span>
                          <span class="score-denominator">{{ item.totalSeconds || 0 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="middle-info">
                <div class="brain-waves">
                  <div class="wave-grid">
                    <div class="wave-item">
                      <div class="wave-label">Delta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'delta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Beta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'beta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Alpha:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'alpha') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Theta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'theta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Gamma:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'gamma') }} %</div>
                    </div>
                  </div>
                </div>
                <div class="wave-chart-wrapper">
                  <div class="wave-chart" :class="getTreatmentStatusClass(item)">
                    <!-- 图表 DOM 按 roomId 稳定命名，切页复用实例而非每次 dispose+init -->
                    <div :id="getChartDomId(item, index)" :data-room-key="getChartRoomKey(item, index)" class="echarts-container" ref="waveCharts"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import sleepViewChartsMixin from '@/composables/sleepViewChartsMixin';

export default {
  mixins: [sleepViewChartsMixin],
  name: 'SleepViewDefault',
  props: {
    displayedAppointments: { type: Array, default: () => [] },
    currentTime: { type: String, default: '' },
    currentWeekday: { type: String, default: '' },
    currentDate: { type: String, default: '' },
    ongoingTreatmentCount: { type: Number, default: 0 },
    isSliding: { type: Boolean, default: false },
    welcomeMessage: { type: String, default: '' },
    welcomeAnimationState: { type: String, default: '' },
    welcomeMessageStyle: { type: Object, default: () => ({}) },
    helpers: { type: Object, required: true },
    currentPage: { type: Number, default: 0 },
    pageEpoch: { type: Number, default: 0 }
  },
  data() {
    return {
      chartInstances: {},
      chartOptionCache: {},
      lastChartUpdateTime: 0,
      preloadedChartOptions: {},
      bubbleTimers: [], // 气泡动画相关 setTimeout id，组件销毁时统一清理防止内存泄漏
      chartResizeTimers: [] // 图表 resize 的 100ms setTimeout id，组件销毁时统一清理
    };
  },
  watch: {
    /**
     * 第一阶段性能优化：切页 / 滑动不再 dispose 图表。
     * 初始化统一由 sleep.vue → usePageRotation.startSlideAnimation.finish → initCharts 单入口触发。
     * 滑动期间 updateAllCharts / updateChart 内部通过 isSliding 跳过即可。
     */
  },
  beforeDestroy() {
    if (this.bubbleTimers && this.bubbleTimers.length > 0) {
      this.bubbleTimers.forEach(id => clearTimeout(id));
      this.bubbleTimers = [];
    }
    if (this.chartResizeTimers && this.chartResizeTimers.length > 0) {
      this.chartResizeTimers.forEach(tid => clearTimeout(tid));
      this.chartResizeTimers = [];
    }
    // 组件卸载（含 Welcome/Default 切换）时释放 ECharts 实例
    if (this.disposeAllCharts) {
      this.disposeAllCharts();
    }
    this.chartOptionCache = {};
  },
  created() {
    this.preloadedChartOptions = {};
  },
  methods: {
    getPerformanceConfig() {
      return (this.helpers && this.helpers.performanceConfig) || config.performance || {};
    },
    getTreatmentStatus(item) { return this.helpers.getTreatmentStatus(item) },
    getTreatmentStatusClass(item) { return this.helpers.getTreatmentStatusClass(item) },
    formatTimeDisplay(s) { return this.helpers.formatTimeDisplay(s) },
    formatTherapistName(n) { return this.helpers.formatTherapistName(n) },
    getCharacterImage(item) { return this.helpers.getCharacterImage(item) },
    calculateEnergyScore(item) { return this.helpers.calculateEnergyScore(item) },
    getBrainwaveDisplay(item, type) { return this.helpers.getBrainwaveDisplay(item, type) },
    getTreatmentStatusIcon(item) { return this.helpers.getTreatmentStatusIcon(item) },
    getSleepStatus(item) { return this.helpers.getSleepStatus(item) },
    getProgressPercentage(item) { return this.helpers.getProgressPercentage(item) },
    formatPatientName(n) { return this.helpers.formatPatientName(n) },
  }
}
</script>
